import {createContext} from 'react';
import defaultConfig from 'src/internal/config/defaultConfig';

import type {AccessConfig} from 'src/types';

export default createContext<AccessConfig>(defaultConfig);
